import { Routes } from '@angular/router';

import { SettingsComponent } from './settings.component';
import { settingsGuard } from '@core/guards/settings.guard';

export const SETTINGS_ROUTES: Routes = [
  {
    path: 'bi-settings',
    component: SettingsComponent,
    children: [
      {
        path: 'users-and-permissions',
        title: 'Users and Permissions',
        canActivate: [settingsGuard('UsersAndPermissions')],
        loadComponent: () =>
          import(
            './pages/users-and-permissions/users-and-permissions.component'
          ).then(m => m.UsersAndPermissionsComponent),
        children: [
          {
            path: 'users',
            title: 'BI Users',
            loadComponent: () =>
              import(
                './pages/users-and-permissions/bi-users/bi-users.component'
              ).then(m => m.BiUsersComponent),
          },
          {
            path: 'groups-permissions',
            title: 'BI Groups and Permissions',
            loadComponent: () =>
              import(
                './pages/users-and-permissions/bi-groups-permissions/bi-groups-permissions.component'
              ).then(m => m.BiGroupsPermissionsComponent),
          },
          {
            path: '',
            redirectTo: 'groups-permissions',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'dashboards-settings',
        title: 'Dashboards Settings',
        canActivate: [settingsGuard('RolesAndPermissions')],
        loadComponent: () =>
          import(
            './pages/dashboards-settings/dashboards-settings.component'
          ).then(m => m.DashboardsSettingsComponent),
      },
    ],
  },
];
